/**
 * Wait for an element before resolving a promise
 * @param {String} querySelector - Selector of element to wait for
 * @param {Integer} timeout - Milliseconds to wait before timing out, or 0 for no timeout
 */
function waitForElement(querySelector, timeout) {
	// eslint-disable-next-line consistent-return
	return new Promise((resolve, reject) => {
		let timer = false;
		if (document.querySelectorAll(querySelector).length) return resolve();
		// eslint-disable-next-line consistent-return
		const observer = new MutationObserver(() => {
			if (document.querySelectorAll(querySelector).length) {
				observer.disconnect();
				if (timer !== false) clearTimeout(timer);
				return resolve();
			}
		});
		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
		if (timeout) {
			timer = setTimeout(() => {
				observer.disconnect();
				reject();
			}, timeout);
		}
	});
}

waitForElement('#gform_14', 3000).then(() => {
	// console.log('element is loaded.. do stuff');
	// console.log(window.location.pathname);
	const form = document.getElementById('gform_14');
	const inputs = form.getElementsByTagName('input');
	const inputsArray = Array.from(inputs);

	if (window.location.pathname === '/brain-health/lifestyle/vital-minds/') {
		inputsArray.forEach((input) => {
			// console.log(input.value);
			if (input.value === 'vital-minds') {
				// console.log('TRUE');
				input.checked = true;
			}
		});
	}

	if (window.location.pathname === '/brain-health/lifestyle/memory-care/') {
		inputsArray.forEach((input) => {
			// console.log(input.value);
			if (input.value === 'memory-care') {
				// console.log('TRUE');
				input.checked = true;
			}
		});
	}

	if (window.location.pathname === '/brain-health/lifestyle/healthy-aging/') {
		inputsArray.forEach((input) => {
			// console.log(input.value);
			if (input.value === 'brain-wellness-consult') {
				// console.log('TRUE');
				input.checked = true;
			}
		});
	}

	console.log(window.location.pathname);
	if (window.location.pathname === '/brain-health/lifestyle-coaching/') {
		// console.log('inner breach1');
		inputsArray.forEach((input) => {
			if (input.value === 'lifestyle-coaching') {
				input.checked = true;
				// console.log(`${input} is being checked`);
			}
		});
	}
}).catch(() => {
	console.log('element did not load in 3 seconds');
});
